const menuItemGroupProps = {
  title: String
};
export { menuItemGroupProps };